<!-- eslint-disable -->
<template>
  <loading v-model:active="isLoading" :is-full-page="fullPage" />
  <div id="main" class="layout-horizontal">
    <PrimaryTopBar />
    <div class="content-wrapper container">
      <div class="page-heading" v-show="isHome">
        <h3><router-link :to="{path: '/dashboard'}" class="icon-back"><i class="bi bi-chevron-left"></i></router-link> Petunjuk Pembayaran BPP</h3>
      </div>

      <div class="page-content" v-show="isHome">
        <section class="row">
          <div class="col-12 col-lg-3">
            <div class="card">
              <div class="card-content">
                <img src="/images/petunjuk/bsi.png" class="card-img-top img-fluid" alt="singleminded">
                <div class="card-body">
                  <button  class="btn btn-success-new btn-block shadow-lg mt-2 rounded-pill" @click.prevent="onBSM()">Bank BSI ex BSM</button>
                </div>
              </div>
            </div>
         </div>
         <div class="col-12 col-lg-3">
            <div class="card">
              <div class="card-content">
                <img src="/images/petunjuk/bsi.png" class="card-img-top img-fluid" alt="singleminded">
                <div class="card-body">
                  <button  class="btn btn-success btn-block shadow-lg mt-2 rounded-pill" @click.prevent="onBRIS()">Bank BSI ex BRIS</button>
                </div>
              </div>
            </div>
         </div>
         <div class="col-12 col-lg-3">
            <div class="card">
              <div class="card-content">
                <img src="/images/petunjuk/bankmuamalat.jpg" class="card-img-top img-fluid" alt="singleminded">
                <div class="card-body">
                  <button  class="btn btn-purple btn-block shadow-lg mt-2 rounded-pill" @click.prevent="onBMI()">Bank Muamalat</button>
                </div>
              </div>
            </div>
         </div>
         <div class="col-12 col-lg-3">
            <div class="card">
              <div class="card-content">
                <img src="/images/petunjuk/bank_lain.png" class="card-img-top img-fluid" alt="singleminded">
                <div class="card-body">
                  <button  class="btn btn-warning btn-block shadow-lg mt-2 rounded-pill"  @click.prevent="onBankL()">Bank Lain</button>
                </div>
              </div>
            </div>
         </div>
        </section>
      </div>

      <div class="page-heading"  v-show="isBSM">
        <h3><a @click.prevent="onHome()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Petunjuk Bank BSI ex BSM (Syariah Mandiri)</h3>
      </div>
      <PetunjukBSM v-bind:dataSiswa="biodata" v-bind:jumlahTagihan="jumlahTagihanBSM" v-show="isBSM"/>

      <div class="page-heading"  v-show="isBRIS">
        <h3><a @click.prevent="onHome()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Petunjuk Bank BSI ex BRIS (BRI Syariah)</h3>
      </div>
      <PetunjukBRIS v-bind:dataSiswa="biodata" v-show="isBRIS"/>

      <div class="page-heading"  v-show="isBMI">
        <h3><a @click.prevent="onHome()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Petunjuk Bank Muamalat</h3>
      </div>
      <PetunjukBMI v-bind:dataSiswa="biodata" v-bind:jumlahTagihan="jumlahTagihanBMI"  v-show="isBMI"/>

      <div class="page-heading"  v-show="isBankL">
        <h3><a @click.prevent="onHome()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Petunjuk Bank Lain</h3>
      </div>
      <PetunjukBankLain v-bind:dataSiswa="biodata"  v-bind:tagihanBMI="jumlahTagihanBMI" v-bind:tagihanBSM="jumlahTagihanBSM" v-show="isBankL"/>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import axios from "axios";
import PrimaryTopBar from "@/components/layout/PrimaryTopBar.vue";
import PetunjukBSM from "@/components/PetunjukPembayaran/BankBSM.vue";
import PetunjukBRIS from "@/components/PetunjukPembayaran/BankBRIS.vue";
import PetunjukBMI from "@/components/PetunjukPembayaran/BankBMI.vue";
import PetunjukBankLain from "@/components/PetunjukPembayaran/BankLain.vue";
import Loading from 'vue-loading-overlay';

export default {
  name: "Dashboard",
  components: {
    PrimaryTopBar,
    PetunjukBSM,
    PetunjukBRIS,
    PetunjukBMI,
    PetunjukBankLain,
    Loading
  },
  data() {
    return {
      biodata : [],
      getKey : '',
      isLoading : false,
      fullPage : true,
      isHome : true,
      isBSM : false,
      isBRIS : false,
      isBMI : false,
      isBankL : false,
      jumlahTagihanBSM : 0,
      jumlahTagihanBMI : 0
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      this.isHome = true;
      this.isLoading = true;
      if(localStorage.getItem('setusers')){
        this.biodata = JSON.parse(localStorage.getItem('setusers'));
        this.getKey  = localStorage.getItem('token');
      }
      this.getTagihan();
      setTimeout(() => {
        this.isLoading = false;
      }, 1500);
    },
    async getTagihan() {
      this.isLoading = true;
      this.formTagihan = { nis:this.biodata.nis, key:this.getKey };
      await axios.post('/api/public/tagihan',JSON.stringify(this.formTagihan)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            let row = data.records;

            if(row.code === '00') {
              let jumlah = row.data.totalNominal;
              this.jumlahTagihanBSM = (jumlah > 0) ? jumlah : 0;
              this.jumlahTagihanBMI = (jumlah > 0) ? jumlah + 1000 : 0;
            }
          }
      });
    },
    async onBSM () { 
      this.isHome = false;
      this.isBSM = true;
      this.isBRIS = false;
      this.isBMI = false;
      this.isBankL = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async onBRIS () { 
      this.isHome = false;
      this.isBSM = false;
      this.isBRIS = true;
      this.isBMI = false;
      this.isBankL = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async onBMI () { 
      this.isHome = false;
      this.isBSM = false;
      this.isBRIS = false;
      this.isBMI = true;
      this.isBankL = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async onBankL () {
      this.isHome = false;
      this.isBSM = false;
      this.isBRIS = false;
      this.isBMI = false;
      this.isBankL = true;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    async onHome () {
      this.isHome = true;
      this.isBSM = false;
      this.isBRIS = false;
      this.isBMI = false;
      this.isBankL = false;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
  }
}
</script>